import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import { getProducts, deleteProduct } from '../../api';
import { useToast } from '../../components/Toast';
import Loader from '../../components/Loader';

export default function AdminProducts() {
  const [products, setProducts] = useState(null);
  const { toast, ToastHost } = useToast();

  const load = () => getProducts().then(setProducts).catch(() => setProducts([]));
  useEffect(() => { load(); }, []);

  const handleDelete = async (p) => {
    if (!window.confirm(`Delete "${p.name}"?`)) return;
    try {
      await deleteProduct(p._id);
      toast('Product deleted');
      load();
    } catch (e) {
      toast('Delete failed', 'error');
    }
  };

  if (!products) return <Loader />;

  return (
    <div>
      <div className="acontent__head">
        <h1>Products <span className="muted" style={{ fontSize: 16 }}>({products.length})</span></h1>
        <Link to="/admin/products/new" className="btn btn-primary btn-sm"><FiPlus /> Add Product</Link>
      </div>

      {products.length === 0 ? (
        <div className="empty"><div className="empty__icon">📦</div><h3>No products yet</h3><Link to="/admin/products/new" className="btn btn-primary mt-2">Add your first product</Link></div>
      ) : (
        <div className="table-wrap">
          <table className="atable">
            <thead>
              <tr><th></th><th>Name</th><th>Category</th><th>Price</th><th>Colours</th><th>Featured</th><th></th></tr>
            </thead>
            <tbody>
              {products.map((p) => (
                <tr key={p._id}>
                  <td><img className="thumb" src={p.images?.[0] || p.colors?.[0]?.images?.[0] || '/logo.png'} alt="" /></td>
                  <td>{p.name}</td>
                  <td><span className="badge">{p.category}</span></td>
                  <td>₹{Number(p.price).toLocaleString('en-IN')}</td>
                  <td>
                    <div className="flex gap">
                      {(p.colors || []).slice(0, 4).map((c, i) => (
                        <span key={i} className="swatch" style={{ background: c.hex, width: 16, height: 16 }} title={c.name} />
                      ))}
                    </div>
                  </td>
                  <td>{p.featured ? '⭐' : '—'}</td>
                  <td>
                    <div className="row-actions">
                      <Link to={`/admin/products/${p._id}`} className="icon-btn"><FiEdit2 /></Link>
                      <button className="icon-btn danger" onClick={() => handleDelete(p)}><FiTrash2 /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <ToastHost />
    </div>
  );
}
